import React from 'react'
import { SearchBar } from '../SearchBar'
import { Table } from 'reactstrap';
import { useDispatch } from 'react-redux';
import ConfirmationModal from '../ConfirmationMessage';
import { PageLength } from '../PageLength';
import FullPageLoader from '../FullPageLoader';
import moment from 'moment-timezone';
import LiveClock from '../LiveClock';
import useDebounce from 'hooks/useDebounce';
import DebouncedInput from '../DebounceInput';
import Pagination from 'components/Pagination';
import { Link, useNavigate } from 'react-router-dom';
import { SubmitButton } from '../buttons/SubmitButton';


export const PAGELENGTH = 10;


export const ListLayout = ({
    heading,
    renderFilters,
    renderCards,
    children,
    footer,
    time,
    title,
    noOfItems,
    buttonTitle,
    renderTableHeader,
    renderTableContent,
    totalPages,
    fetchList,
    selectedItems,
    handleRemoveItems,
    refAddutton,
    renderAddForm,
    renderAddLink,
    addForm,
    handleAddPopUp,
    showConfirmDialog,
    showMoveConfirmDialog,
    searchTerm, setSearchTerm,
    sortConfig,
    addButtonDisabled = false,
    hideRemoveButton = false,
    renderFooter,
    hidePagination,
    hidePageLength,
    hideSearchBar,
    searchPlaceholder,
    loader,
    containerStyle,
    showRemoveOnTop,
    hideHeader,
    tableHide = false,
    colLength,
    fullMainHead,
    refAddPopUp = "#exampleModal",
    haveBackBtn = false,
    onBackButtonClick,
    disableBootstrap,
    addformModal = true,
    invoiceButton = false,
    paymentButton = false,
    height,
    hideMoveButton = true,
    paginationParams,
    defaultPageLength = PAGELENGTH,
    // ---- opt-in controlled mode (see helpers/listQuery.js) ----
    // Pass BOTH `query` and `onQueryChange` and the owning page becomes the single source of
    // truth for page / pageLength / sort / search, and does its own fetching. Without them this
    // component behaves exactly as before, so the other admin lists are untouched.
    query,
    onQueryChange,
}) => {
    const dispatch = useDispatch();
    const controlled = Boolean(query && onQueryChange);
    const [uncontrolledPage, setCurrentPage] = React.useState(1);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [timeoutId, setTimeoutId] = React.useState(null);
    const [uncontrolledPageLength, setPageLength] = React.useState(defaultPageLength)
    // The search box needs to echo each keystroke while the request itself is debounced, so in
    // controlled mode the input keeps a draft and follows `query.search` when the page changes it
    // (that is what makes the Reset button able to clear the box).
    const [searchDraft, setSearchDraft] = React.useState(query?.search ?? '');
    const navigate = useNavigate();

    const currentPage = controlled ? (query.page ?? 1) : uncontrolledPage;
    const pageLength = controlled ? (query.pageLength ?? defaultPageLength) : uncontrolledPageLength;
    const searchValue = controlled ? searchDraft : searchTerm;

    React.useEffect(() => {
        if (controlled) setSearchDraft(query.search ?? '');
    }, [controlled, query?.search]);

    const handlePageLength = React.useCallback((length) => {
    if (controlled) {
        onQueryChange({ pageLength: length });
        return;
    }

    setPageLength(length);

    const page = 1;

    const updatedFilters = {
        ...paginationParams,
        page,
    };

    dispatch(
        fetchList(page, {
            ...sortConfig,
            search: searchTerm,
            pageLength: length,
            ...updatedFilters,
        })
    );

    setCurrentPage(page); // reset current page to 1
}, [controlled, onQueryChange, sortConfig, searchTerm, paginationParams]);


    const handlePageChange = React.useCallback((page) => {
        if (controlled) {
            onQueryChange({ page });
            return;
        }

        setCurrentPage(page);

        const updatedFilters = {
            ...paginationParams,
            page,
        };

        dispatch(fetchList(page, { ...sortConfig, search: searchTerm, pageLength, ...updatedFilters }, true));
    }, [controlled, onQueryChange, sortConfig, searchTerm, pageLength, paginationParams]);

    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }


    const handleSearch = (value) => {
        if (controlled) setSearchDraft(value);
        setSearchTerm?.(value);

        // Clear the previous timeout if the user is still typing
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        // Set a new timeout to call the API after a delay
        const newTimeoutId = setTimeout(() => {
            if (controlled) {
                onQueryChange({ search: value });
                return;
            }
            const disableLoader = true;
            setCurrentPage(1)
            dispatch(fetchList(1, { ...sortConfig, search: value, ...paginationParams}, disableLoader));
        }, 500); // 500ms delay

        setTimeoutId(newTimeoutId);
    };


    const renderPagination = React.useCallback(() => {
        return (
            <div className="table-pagination pagebtn-u">
                <button
                    disabled={totalPages <= 1 || currentPage == 1}
                    className={`${(totalPages <= 1 || currentPage == 1) && "disabled-button"}`}
                    onClick={() => handlePageChange(currentPage - 1)}
                >
                    Previous
                </button>
                {
                    Array(totalPages).fill(0).map((count, index) => (
                        <button key={index} className={currentPage === index + 1 ? "active" : ""}
                            onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))
                }
                <button
                    disabled={totalPages <= 1 || currentPage == totalPages}
                    className={`${(totalPages <= 1 || currentPage == totalPages) && "disabled-button"}`}
                    onClick={() => handlePageChange(currentPage + 1)}
                >
                    Next
                </button>
            </div>
        )
    }, [
        currentPage,
        totalPages,

    ])

    const handleSearchSubmit = React.useCallback(() => {

        dispatch(fetchList(currentPage, { ...sortConfig, search: searchTerm }));
    }, [sortConfig, searchTerm, currentPage])


    return (
        <>
            <div className={`content ${height}`} style={containerStyle}>
                <div className="row_main_head">
                    <div className='d-flex align-items-center gap-2'>
                        {haveBackBtn &&
                            <button className="main_heading back_button" onClick={() => onBackButtonClick ? onBackButtonClick() : navigate(-1)}>
                                <i className="fa-solid fa-arrow-left"></i> Back
                            </button>
                        }
                        <h2 className={`main_heading ${fullMainHead}`}>{heading}</h2>
                    </div>

                    {/* {time && <LiveClock />} */}
                </div>

                {renderCards &&
                    <div className=''>
                        {/* filters  */}
                        {renderCards && renderCards()}
                    </div>
                }

                <div className="card_table">

                    {renderFilters &&
                        <div className='row_table_head'>
                            {/* filters  */}
                            {renderFilters && renderFilters()}
                        </div>
                    }
                    {!hideHeader && <div className="row_table_head">
                        <div className="flex justify-content-center">
                            {title && <h3 className="sub_heading mb-3" >{title}</h3>}
                            {!hidePageLength && <PageLength handlePageLength={handlePageLength} pageLength={tableHide ? 0 : pageLength} total={noOfItems} />}
                        </div>


                        <div className="row_table_head" style={{ alignItems: "center", padding: 0 }} >

                            <div className="mx-4 d-flex align-items-center gap-2">
                                {hideMoveButton || selectedItems?.length > 0 &&
                                    <SubmitButton onClick={showMoveConfirmDialog} buttonType="button" btnText="Move" className="green" />
                                }
                                {hideRemoveButton || selectedItems?.length > 0 &&
                                    <button onClick={showConfirmDialog} className="table_delete">Delete</button>
                                }
                            </div>

                            {invoiceButton && selectedItems?.length > 0 && <div className="mx-4">
                                <button className="table_delete">Generate Invoices</button>
                            </div>}

                            {paymentButton && selectedItems?.length > 0 && <div className="mx-4">
                                <button onClick={showConfirmDialog} className="main_button">Paid</button>
                            </div>}

                            {renderFooter && renderFooter()}
                            {!hideSearchBar && <SearchBar
                                placeholder={searchPlaceholder}
                                handleChange={handleSearch}
                                keywords={searchValue}
                            // handleSubmit={handleSearchSubmit}
                            />
                            }
                            {addformModal ? (
                                !addButtonDisabled && (
                                    disableBootstrap ? (
                                        <button
                                            type="button"
                                            className="main_button ml-4"
                                            onClick={handleAddPopUp}
                                        >
                                            {buttonTitle}
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            ref={refAddutton}
                                            className="main_button ml-4"
                                            data-bs-toggle="modal"
                                            data-bs-target={refAddPopUp}
                                            onClick={handleAddPopUp}
                                        >
                                            {buttonTitle}
                                        </button>
                                    )
                                )
                            ) : (
                                renderAddLink(() => {
                                    setSearchTerm?.("")
                                })
                            )}

                        </div>
                    </div>
                    }



                    <div className='table_responsive'>
                        <Table>
                            <thead className="text-primary">
                                {renderTableHeader()}
                            </thead>
                            <tbody>

                                {!tableHide ? renderTableContent()
                                    :
                                    // no data available
                                    <tr>
                                        <td colSpan={colLength} align='right' style={{ textAlign: "center" }} >No Data Available</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </div>

                    <div className="row_end justify-content-between">
                        <div className="">
                            {/* {!hidePagination && renderPagination()} */}
                            {(!tableHide && !hidePagination) && <Pagination
                                totalItems={noOfItems}
                                currentPage={currentPage}
                                pageLength={pageLength}
                                totalPages={totalPages}
                                handleChange={handlePageChange}
                                prevDisabled={totalPages <= 1 || currentPage == 1}
                                nextDisabled={totalPages <= 1 || currentPage == totalPages}
                            />}
                        </div>

                        {/* {hideRemoveButton || selectedItems.length > 0 && <div className="row_end float-right" style={{
                            display: showRemoveOnTop ? "none" : "flex"
                        }}>
                            <button onClick={showConfirmDialog} className="table_delete">Delete</button>
                        </div>} */}

                    </div>
                </div>
            </div>
            {children}
            {renderAddForm && renderAddForm(() => {
                setSearchTerm?.("")
            })}

            {loader && <FullPageLoader />}
        </>
    )
}

